
import { FC, useContext, useEffect } from 'react';
import { DefaultLotCreateLink, DefaultProjectCreateLink, DefaultStageCreateLink, ILinkContext, LinkContext } from '../../contexts/layouts/LinkContext';


interface ISetLinksProps {
    createProjectLink?: ILinkContext['createProjectLink'];
    createStageLink?: ILinkContext['createStageLink'];
    createLotLink?: ILinkContext['createLotLink'];
    projectLinkEnabled?: ILinkContext['projectLinkEnabled'];
    stageLinkEnabled?: ILinkContext['stageLinkEnabled'];
    lotLinkEnabled?: ILinkContext['lotLinkEnabled'];
}

const SetLinks: FC<ISetLinksProps> = ({
    createProjectLink,
    createStageLink,
    createLotLink,
    projectLinkEnabled,
    stageLinkEnabled,
    lotLinkEnabled
}) => {

    const { setCreateStageLink, setCreateProjectLink, setStageLinkEnabled, setProjectLinkEnabled, setCreateLotLink, setLotLinkEnabled } = useContext(LinkContext);

    useEffect(() => {
        if (createProjectLink) {
            setCreateProjectLink(createProjectLink);

            return () => {
                setCreateProjectLink(DefaultProjectCreateLink)
            }
        }
    }, [setCreateProjectLink, createProjectLink])

    useEffect(() => {
        if (createStageLink) {
            setCreateStageLink(createStageLink);

            return () => {
                setCreateStageLink(DefaultStageCreateLink)
            }
        }
    }, [setCreateStageLink, createStageLink])

    
    useEffect(() => {
        if (createLotLink) {
            setCreateLotLink(createLotLink);

            return () => {
                setCreateLotLink(DefaultLotCreateLink)
            }
        }
    }, [setCreateLotLink, createLotLink])

    useEffect(() => {
        if (projectLinkEnabled !== undefined) {
            setProjectLinkEnabled(projectLinkEnabled);

            return () => {
                setProjectLinkEnabled(true)
            }
        }
    }, [setProjectLinkEnabled, projectLinkEnabled])

    useEffect(() => {
        if (stageLinkEnabled !== undefined) {
            setStageLinkEnabled(stageLinkEnabled);

            return () => {
                setStageLinkEnabled(true)
            }
        }
    }, [setStageLinkEnabled, stageLinkEnabled])

    useEffect(() => {
        if (lotLinkEnabled !== undefined) {
            setLotLinkEnabled(lotLinkEnabled);

            return () => {
                setLotLinkEnabled(true)
            }
        }
    }, [setLotLinkEnabled, lotLinkEnabled])

    return null;
}

export default SetLinks